exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.margin-bottom[data-v-146c1336]{margin-bottom:20px\n}\n.margin-bottom15[data-v-146c1336]{margin-bottom:15px\n}\n.margin-left[data-v-146c1336]{margin-left:10px;margin-top:10px\n}\n.color[data-v-146c1336]{color:black\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/analise/vtn/components/Observacoes.vue"],"names":[],"mappings":";AAkCA,gCACE,kBAAmB;CACpB;AAAA,kCAGC,kBAAmB;CACpB;AAAA,8BAGC,iBACA,eAAgB;CACjB;AAAA,wBAGC,WAAY;CACb","file":"Observacoes.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.margin-bottom {\n  margin-bottom: 20px;\n}\n\n.margin-bottom15 {\n  margin-bottom: 15px;\n}\n\n.margin-left {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\n.color {\n  color: black;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-146c1336","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/analise/vtn/components/Observacoes.vue
// module id = 2tIW
// module chunks = 11